import { tv } from 'tailwind-variants';
import { sendRespawn } from '../../network/NetworkClient';
import { clearColonyLost, isColonyLost } from '../../state/colonyLost';
import { isEscMenuOpen } from '../../state/escMenu';
import { t } from '../../state/i18n';

const overlay = tv({
  base: 'fixed inset-0 flex items-center justify-center z-[9998]',
});

const backdrop = tv({
  base: 'absolute inset-0 bg-slate-950/90 backdrop-blur-sm',
});

const card = tv({
  base: 'relative w-full max-w-lg mx-4 bg-gradient-to-b from-slate-900 to-slate-950 rounded-2xl border border-red-500/20 shadow-2xl shadow-red-500/10 overflow-hidden',
});

const header = tv({
  base: 'px-6 py-5 border-b border-slate-800/50 bg-red-500/5 flex items-center gap-4',
});

const skullIcon = tv({
  base: 'w-14 h-14 rounded-full bg-red-500/20 border-2 border-red-500/40 flex items-center justify-center',
});

const content = tv({
  base: 'p-6 space-y-4',
});

const respawnButton = tv({
  base: 'w-full px-6 py-3 rounded-lg font-mono text-sm font-medium transition-all duration-200 bg-indigo-600 hover:bg-indigo-500 text-white cursor-pointer',
});

const SkullSvg = () => (
  <svg
    class="w-7 h-7 text-red-400"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    />
  </svg>
);

export const ColonyLostOverlay = () => {
  if (!isColonyLost.value || isEscMenuOpen.value) {
    return null;
  }

  const handleRespawn = () => {
    clearColonyLost();
    sendRespawn();
  };

  return (
    <div class={overlay()}>
      <div class={backdrop()} />
      <div class={card()}>
        <div class={header()}>
          <div class={skullIcon()}>
            <SkullSvg />
          </div>
          <div>
            <h2 class="text-lg font-semibold text-white">{t('ui.colonyLost.title')}</h2>
            <p class="text-sm text-slate-400 mt-0.5">{t('ui.colonyLost.subtitle')}</p>
          </div>
        </div>
        <div class={content()}>
          <div class="bg-slate-800/50 border border-slate-700/30 rounded-lg p-4">
            <p class="text-sm text-slate-300 leading-relaxed">{t('ui.colonyLost.description')}</p>
          </div>
          <button type="button" class={respawnButton()} onClick={handleRespawn}>
            {t('ui.colonyLost.respawn')}
          </button>
        </div>
      </div>
    </div>
  );
};
